import PriceSectionItem, { PriceSectionItemProps } from './PriceSectionItem';

export type { PriceSectionItemProps };
export default PriceSectionItem;
